import Nullstack from 'nullstack';
export default function IconRazorElectric({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-razor-electric",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 3v2"
  }), "   ", Nullstack.element("path", {
    d: "M12 3v2"
  }), "   ", Nullstack.element("path", {
    d: "M16 3v2"
  }), "   ", Nullstack.element("path", {
    d: "M9 12v6a3 3 0 0 0 6 0v-6h-6z"
  }), "   ", Nullstack.element("path", {
    d: "M8 5h8l-1 4h-6z"
  }), "   ", Nullstack.element("path", {
    d: "M12 17v1"
  }), " ");
}